var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "leo-flex leo-flex-col leo-justify-between leo-items-center leo-min-h-screen",
    },
    [
      _c("div", [_c("Header")], 1),
      _c(
        "div",
        {
          staticClass:
            "leo-z-1 leo-container leo-flex leo-flex-col leo-justify-items-start leo-h-full desktop:leo-h-auto leo-w-full leo-relative leo-flex-grow",
        },
        [
          _vm.renderRefresh ? _c("refresh-page") : _vm._e(),
          _c("alert", { staticClass: "tablet:leo-mt-xl tablet:leo--mb-xl" }),
          _c(
            "main",
            {
              staticClass:
                "leo-flex leo-flex-col leo-justify-between leo-flex-grow",
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "leo-row tablet:leo-gap-md tablet:leo-py-7xl leo-flex-grow",
                },
                [
                  _c(
                    "div",
                    {
                      class: [
                        _vm.isDesktopChannel
                          ? "leo-col-12 tablet:leo-col-4 tablet:leo-offset-2 desktop:leo-col-6 desktop:leo-offset-3"
                          : "leo-col-12 tablet:leo-px-3xl",
                      ],
                    },
                    [
                      _vm.isChangePasswordFlow
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "leo-text-2xl leo-mx-xl leo-text-secondary leo-font-semibold leo-pb-2xl",
                            },
                            [_vm._v(" Change Password ")]
                          )
                        : _vm._e(),
                      _c(
                        "leo-card",
                        {
                          staticClass:
                            "leo-rounded-none leo-shadow-none leo-h-full tablet:leo-rounded-md tablet:leo-px-xl tablet:leo-shadow-4 desktop:leo-mx-xl tablet:leo-h-auto",
                        },
                        [_vm._t("default")],
                        2
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm.isDesktopChannel
        ? _c(
            "div",
            {
              staticClass:
                "leo-hidden tablet:leo-block leo-z-0 leo-fixed leo-bottom-0 leo-flex leo-flex-col leo-items-stretch leo-justify-end",
            },
            [
              _c("img", {
                attrs: {
                  src: require("../assets/images/GreatID_Image_BG.svg"),
                  alt: "Sign In Background Image",
                },
              }),
            ]
          )
        : _vm._e(),
      _vm.isDesktopChannel
        ? _c(
            "div",
            {
              staticClass:
                "leo-z-1 leo-row leo-hidden tablet:leo-flex leo-w-screen",
            },
            [_c("Footer")],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }